import { Transaction } from "../models/TransactionModel";

export const sumProperty = (transactions: any[], property: string): number => {
  return transactions.reduce(
    (total, transaction) => total + (Number(transaction[property]) || 0),
    0
  );
};
